var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58064 9.9C5.84105 9.9 3.6129 7.67981 3.6129 4.95C3.6129 2.22019 5.84105 0 8.58064 0C11.3202 0 13.5484 2.22019 13.5484 4.95C13.5484 7.67981 11.3202 9.9 8.58064 9.9ZM8.58064 0.9C6.33952 0.9 4.51613 2.71688 4.51613 4.95C4.51613 7.18313 6.33952 9 8.58064 9C10.8218 9 12.6452 7.18313 12.6452 4.95C12.6452 2.71688 10.8218 0.9 8.58064 0.9ZM15.8065 18H1.35484C0.607984 18 0 17.3942 0 16.65C0 16.5887 0.0124193 15.1335 1.10645 13.68C1.74323 12.834 2.61484 12.1618 3.69758 11.6831C5.01968 11.097 6.66298 10.8 8.58065 10.8C10.4983 10.8 12.141 11.097 13.4637 11.6831C14.5465 12.1629 15.4181 12.834 16.0548 13.68C17.1489 15.1335 17.1613 16.5887 17.1613 16.65C17.1613 17.3942 16.5533 18 15.8065 18ZM8.58064 11.7C5.43121 11.7 3.1071 12.5578 1.85952 14.1806C0.924677 15.3968 0.90379 16.6393 0.903226 16.6523C0.903226 16.8986 1.10532 17.1006 1.35484 17.1006H15.8065C16.056 17.1006 16.2581 16.8992 16.2581 16.6506C16.2581 16.6399 16.2372 15.3968 15.3018 14.1812C14.0536 12.5584 11.7295 11.7006 8.58064 11.7006V11.7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOutline);
export default __webpack_public_path__ + "static/media/user-outline.2a67e31923040b8ec0bfffd8611a5cef.svg";
export { ForwardRef as ReactComponent };